export default __webpack_public_path__ + "static/media/redemption_cheers.52dc8d5e.png";